import React from 'react';

import {
    Box,
    FlexBox,
    FullScreen,
    Progress,
    Text
} from 'spectacle';

// SPECTACLE_CLI_TEMPLATE_START
const template = ({ slideNumber, numberOfSlides }) => (
    <FlexBox
        justifyContent="flex-start"
        position="absolute"
        bottom={0}
        width={1}
        backgroundColor="tertiary"
    >
        <Box marginLeft={3} marginRight={3}>
            <FullScreen />
        </Box>
        <Box marginLeft="auto" marginRight="auto" marginBottom={3}>
            <Progress />
            <Text fontSize="18px">
                Slide {slideNumber} of {numberOfSlides}
            </Text>
        </Box>
    </FlexBox>
);
// SPECTACLE_CLI_TEMPLATE_END

export default template;
